<template>
    <div v-show="show">
        <div class="model">
            <div class="title">
                <div class="btn cancel" @click="cancel">取消</div>
                <span>地图选点</span>
                <div class="btn confirm" @click="confirm">确定</div>
            </div>
            <div class="search-wrap">
                <div class="search">
                    <input v-model="searchKey" class="search-input-item" id="search-key" placeholder="请输入搜索关键词" />
                    <van-button class="btn" type="info" size="small" @click="searchLocation">搜索</van-button>
                </div>
                <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
            </div>
            <div class="box" id="map-container"></div>
        </div>
        <div class="mark"></div>
    </div>
</template>
<script>
export default {
    name: "picker-area",
    props: ['keyword'],
    data() {
        return {
            show: false,
            searchKey: this.keyword || '',
            lng: '',
            lat: '',
            mapObj: '',
            mapAC: '',
        };
    },
    mounted() {},
    methods: {

        // 打开
        open() {
            this.show = true
            setTimeout(() => this._onInitMap(), 500);
        },

        // 关闭
        close() {
            this.show = false
            this._onSettingResultStyle();
        },

        _onSettingResultStyle(show = false) {
            let doms = document.querySelectorAll('.tangram-suggestion-main');
            setTimeout(() => {
                doms.forEach((item) => {
                    item.style.zIndex = show ? 9999 : -1;
                })
            }, 0)
        },

        // 初始化地图
        _onInitMap() {
            let _this = this;
            if (this.mapObj) return;
            console.log('this.mapObj---->', this.mapObj);
            this.mapObj = new BMapGL.Map("map-container", {
                enableRotate: false, // 禁止地图旋转
                enableTilt: false, // 禁止地图倾斜
            }); // 创建地图实例
            console.log('this.mapObj---->', this.mapObj);
            var point = new BMapGL.Point(116.404, 39.915); // 创建点坐标
            this.mapObj.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
            let zoomCtrl = new BMapGL.ZoomControl();  // 添加缩放控件
            this.mapObj.addControl(zoomCtrl);

            // 建立一个自动完成的对象
            this.mapAC = new BMapGL.Autocomplete({
                input: "search-key",
                location: this.mapObj,
            });
            this.mapAC.setInputValue(this.keyword)
            this.mapAC.search(this.keyword)
            this._onSettingResultStyle(true);

            var geolocation = new BMapGL.Geolocation();
            geolocation.getCurrentPosition(function(res) {
                console.log('getCurrentPosition---->', res);
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    console.log('_this.searchKey---->', _this.searchKey);
                    if (!_this.searchKey) {
                        var mk = new BMapGL.Marker(res.point);
                        _this.mapObj.addOverlay(mk);
                        _this.mapObj.panTo(res.point);
                    } else {
                        _this.searchLocation();
                    }
                    console.log('您的位置：' + res.point.lng + ',' + res.point.lat);
                } else {
                    alert('failed' + this.getStatus());
                }
            });

            this.mapObj.addEventListener("click", (e) => {
                var allOverlay = this.mapObj.getOverlays();
                for (var i = 0; i < allOverlay.length; i++) {
                    this.mapObj.removeOverlay(allOverlay[i]);
                }
                this._onSetPointInfo(e.latlng.lng, e.latlng.lat);
                // 创建点标记
                var point = new BMapGL.Point(e.latlng.lng, e.latlng.lat);
                var marker = new BMapGL.Marker(point);
                // 在地图上添加点标记
                this.mapObj.addOverlay(marker);
            });

            this.mapAC.addEventListener("onhighlight", function(e) { //鼠标放在下拉列表上的事件
                var str = "";
                var _value = e.fromitem.value;
                var value = "";
                if (e.fromitem.index > -1) {
                    value = _value.province + _value.city + _value.district + _value.street + _value.business;
                }
                str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

                value = "";
                if (e.toitem.index > -1) {
                    _value = e.toitem.value;
                    value = _value.province + _value.city + _value.district + _value.street + _value.business;
                }
                str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                document.getElementById("searchResultPanel").innerHTML = str;
            });

            var myValue;
            this.mapAC.addEventListener("onconfirm", function(e) { //鼠标点击下拉列表后的事件
                var _value = e.item.value;
                myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
                _this.searchKey = myValue;
                console.log('myValue---->', myValue);
                document.getElementById("searchResultPanel").innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;

                _this.setPlace(myValue);
            });

        },

        setPlace(myValue) {
            let _this = this;
            _this.mapObj.clearOverlays(); //清除地图上所有覆盖物
            function myFun() {
                var point = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                _this.mapObj.centerAndZoom(point, 18);
                _this.mapObj.addOverlay(new BMapGL.Marker(point)); //添加标注
                _this._onSetPointInfo(point.lng, point.lat);
            }
            var local = new BMapGL.LocalSearch(_this.mapObj, { //智能搜索
                onSearchComplete: myFun
            });
            local.search(myValue);
        },

        // 搜索
        searchLocation() {
            if (!this.searchKey) {
                return this.Message({
                    title: "请输入搜索关键词",
                })
            }
            //创建地址解析器实例
            var myGeo = new BMapGL.Geocoder();
            // 将地址解析结果显示在地图上，并调整地图视野
            myGeo.getPoint(this.searchKey, (point) => {
                console.log('this.searchKey, point---->', this.searchKey, point);
                if (point) {
                    this._onSetPointInfo(point.lng, point.lat);
                    this.mapObj.centerAndZoom(point, 16);
                    this.mapObj.clearOverlays(); //清除地图上所有覆盖物
                    this.mapObj.addOverlay(new BMapGL.Marker(point)); //添加标注
                } else {
                    alert("您选择的地址没有解析到结果！");
                }
            });
        },

        _onSetPointInfo(lng, lat) {
            this.lng = lng;
            this.lat = lat;
        },

        // 点击确认
        confirm() {
            let { lat, lng } = this
            if (!lat || !lng) {
                return this.Message({
                    title: "请选择位置点",
                })
            }
            this.$emit("confirm", {
                lng: this.lng,
                lat: this.lat,
            });
            this.close()
        },
        // 点击取消
        cancel() {
            this.close()
        },
    },
};
</script>
<style lang="less" scoped>
.model {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .title {
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .btn {
            position: absolute;
            height: 50px;
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1c78df;

            &.cancel {
                left: 0;
            }

            &.confirm {
                right: 0;
            }
        }
    }

    .search-wrap {
        left: 0;
        right: 0;
        top: 50px;
        z-index: 999;
        position: absolute;

        .search {
            flex: 1;
            padding: 10px;
            display: flex;
            align-items: center;

            .search-input-item {
                flex: 1;
                height: 32px;
                font-size: 14px;
                background: #fff;
                text-indent: 15px;
                border-radius: 50px;
            }

            /deep/ .van-cell {
                height: 34px;
                padding: 0;
                border-radius: 2px;
                display: flex;
                align-items: center;
            }

            .btn {
                width: 60px;
                margin-left: 10px;
            }
        }
    }


    .box {
        flex: 1;
        width: 100%;
    }
}

.mark {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);
}
</style>